// extracted by mini-css-extract-plugin
export var colorSquare = "_ka-0";
export var danger = "_ka-5";
export var lightPink = "_ka-8";
export var neutralBlue = "_ka-7";
export var neutralYellow = "_ka-6";
export var normal = "_ka-1";
export var primary = "_ka-2";
export var primaryLight = "_ka-3";
export var solidBlack = "_ka-g";
export var solidGreen = "_ka-b";
export var solidLightBlue = "_ka-d";
export var solidNavy = "_ka-c";
export var solidOrange = "_ka-f";
export var solidPink = "_ka-e";
export var solidRed = "_ka-9";
export var solidYellow = "_ka-a";
export var success = "_ka-4";